import React, { useState, useCallback } from 'react';
import { Card, CardBody, Alert as AlertBox } from 'reactstrap';
import { useSelector, useDispatch } from 'react-redux';
import * as subscriptionActions from '../../store/subscriptions/actions';
import Alert from '../../components/Common/Modal/Alert';

import logo from '../../assets/images/logo-sm-dark.png';

const SubscriptionDelete = ({ subscription }) => {
  const admin = useSelector((state) => state.Auth.admin);

  const success = useSelector((state) => state.Subscription.success);
  const error = useSelector((state) => state.Subscription.error);
  const loading = useSelector((state) => state.Subscription.loading);

  const [deleteAlert, setDeleteAlert] = useState(false);

  const dispatch = useDispatch();

  const openDeleteAlert = useCallback(() => {
    dispatch(subscriptionActions.resetMessage());
    setDeleteAlert(true);
  }, []);

  const handleDelete = useCallback(() => {
    dispatch(subscriptionActions.cancelSubscription(subscription.id, admin.id));
  }, [subscription]);

  if (subscription.status === 'canceled') {
    return null;
  }

  return (
    <>
      <Card className="mt-2">
        <CardBody>
          <p className="text-muted">
            Se desideri disattivare il tuo abbonamento, sarà valido fino alla
            data di prossimo pagamento. Dopo questa data non verranno più
            addebitati costi e perderai l'accesso ai servizi.
          </p>
          <div className="alert alert-warning">
            <strong>Attenzione:</strong> Questa azione non può essere annullata.
            Una volta disattivato, dovrai creare un nuovo abbonamento per
            riattivare i servizi.
          </div>
          <button className="btn btn-danger" onClick={openDeleteAlert}>
            <i className="fas fa-times mr-2"></i>
            Disattiva Abbonamento
          </button>
        </CardBody>
      </Card>
      <Alert
        isOpen={deleteAlert}
        type={error ? 'danger' : success ? 'success' : 'custom'}
        title="Sei sicuro di voler disattivare il tuo abbonamento?"
        loading={loading}
        mainIcon={logo}
        confirmBtnLabel="Disattiva"
        cancelBtnLabel={error || success ? 'Chiudi' : 'Annulla'}
        onCancel={() => setDeleteAlert(false)}
        onConfirm={handleDelete}
        disabledBtn={loading}
        disableButtonOnConfirm={true}>
        <h5>{subscription?.name}</h5>
        {error && <AlertBox color="danger">{error}</AlertBox>}
        {success && <AlertBox color="success">{success}</AlertBox>}
      </Alert>
    </>
  );
};

export default SubscriptionDelete;
